import { useContext } from "react";
import {  TypeListContext } from "../context";

export const useTypeList = () => useContext(TypeListContext);
